<template>
  <div
    class="action-card"
    :class="[variant, { hovered: isHovered, 'mobile-web': isMobileWeb }]"
    @click="$emit('click')"
    @mouseenter="$emit('hover', true)"
    @mouseleave="$emit('hover', false)"
  >
    <div class="card-header">
      <slot name="icon">
        <IonIcon v-if="icon" :icon="icon" class="card-icon" />
      </slot>
      <span class="card-title">{{ title }}</span>
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
import { IonIcon } from '@ionic/vue';

defineProps<{
  title: string;
  icon?: string;
  variant?: 'default' | 'danger' | 'no-hover';
  isHovered?: boolean;
  isMobileWeb?: boolean;
}>();

defineEmits<{
  click: [];
  hover: [hovered: boolean];
}>();
</script>

<style scoped>
.action-card {
  background: var(--ion-card-background);
  border-radius: 12px;
  padding: 15px;
  cursor: pointer;
  box-shadow: var(--ion-box-shadow);
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  height: 80px;
  width: 250px;
  z-index: 1;
}

.action-card:hover {
  border: 1px solid var(--ion-input-border-color);
}

/* No-hover variant (for theme card) */
.action-card.no-hover {
  cursor: default !important;
}

.action-card.no-hover.hovered {
  transform: none !important;
  background: var(--ion-background-color) !important;
}

/* Danger variant (for logout) */
.action-card.danger .card-icon {
  color: var(--ion-color-danger);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.card-icon {
  font-size: 24px;
  color: var(--ion-color-primary);
}

.card-title {
  font-weight: 600;
  font-size: 16px;
  color: var(--ion-text-color);
}

/* Mobile styles */
.action-card.mobile-web {
  width: 100%;
  height: auto;
  min-height: 60px;
}

@media (prefers-color-scheme: dark) {
  .action-card {
    box-shadow: var(--ion-box-shadow);
  }

  .action-card.hovered {
    box-shadow: var(--ion-box-shadow-hover);
  }
}
</style>
